export const style = {
  availbleSlotsContainer: (index) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '18px',
    width: '100%',
    fontSize: '14px',
    fontFamily: 'JioType-Medium',
    color: '#050000',
    borderTop: `thin solid ${index == 0 ? '#F6F6F6' : '#D7D7D7'}`
  }),
  totalNumberOfSlotsBox: (numberOfSlots) => {
    const green = {
      color: '#489E42',
      backgroundColor: 'rgb(72, 158, 66, 0.1)'
    }
    const grey = {
      color: '#7D7D7D',
      backgroundColor: '#f2f0f0'
    }
    const orange = {
      color: '#EB0000',
      backgroundColor: 'rgb(235, 0, 0, 0.1)'
    }
    return ({
      textAlign: 'center',
      fontFamily: 'JioType-Bold',
      minWidth: '73px',
      height: '25px',
      padding: '5px 15px',
      borderRadius: '6px',
      fontSize: '10px',
      ...numberOfSlots > 10 ? green : numberOfSlots == 0 ? grey : orange
    })
  },
  cowinDiv: {
    display: 'flex',
    placeContent: 'center',
  },
  cowinButton: {
    width: '100%',
    height: '46px',
    background: '#0028AF 0% 0% no-repeat padding-box',
    boxShadow: '0px 0px 14px #0028AF33',
    borderRadius: '0px 0px 10px 10px',
    outline: 'none',
    textDecoration: 'none',
    border: 'none',
    color: '#fff',
    fontSize: '14px',
    fontFamily: 'JioType-Medium'
  },
  showOnlyAvailableSlotsFlexbox: {
    padding: '18px 14px 20px 15px',
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '14px',
    fontFamily: 'JioType-Medium',
    color: '#000000',
    width: '100%'
  },
}